<template>
  <div>
    <div class="d-flex align-items-center">
      <h3 class="mr-4">{{ unavailabilityDatePeriodTitle }}</h3>
      <button class="btn btn-secondary pr-5 pl-5" @click.prevent="newUnavailability">Ajouter</button>
    </div>
    <div id="unavailability-date-list">
      <unavailability-table-row
        v-for="unavailabilityDate in dateList"
        :key="unavailabilityDate.id"
        :showHub="showHub"
        :unavailabilityDate="unavailabilityDate"
        :date="date" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import UnavailabilityTableRow from './UnavailabilityTableRow'

export default {
  name: "UnavailabilityTable",
  props: ['date', 'unavailabilityDateList'],
  components: {
    UnavailabilityTableRow,
  },
  computed: {
    unavailabilityDatePeriodTitle() {
      let formatDate = moment(this.date, 'YYYY/MM/DD').locale('fr').format(this.$i18n.t('format.pretty_date'));
      return `Vos indisponibilités du ${formatDate}`
    },
    dateList() {
      let momentDate = moment(`${this.date}T00:00`, "YYYY-MM-DDTHH:mm")
      let startOfDay = momentDate.clone().startOf('day');
      let endOfDay = momentDate.clone().endOf('day');
      return this.unavailabilityDateList.filter((d) => {
        return moment(d.end_at, "YYYY-MM-DDTHH:mm:ss.SSSSZ").isAfter(startOfDay) &&
          moment(d.start_at, "YYYY-MM-DDTHH:mm:ss.SSSSZ").isBefore(endOfDay)
      });
    },
    withOfferProvider() {
      return this.unavailabilityDateList.filter((unavailability) => unavailability.provider == 'offer');
    },
    hasOfferProviders() {
      return this.withOfferProvider.length > 0;
    },
    hasRealHubs() {
      return this.withOfferProvider.filter((unavailability) => {
        return (unavailability.offer &&
                unavailability.offer.hub &&
                !unavailability.offer.hub.is_fake);
      }).length > 0;
    },
    showHub() {
      return this.hasOfferProviders && this.hasRealHubs
    }
  },
  methods: {
    newUnavailability() {
      this.$store.commit('unavailabilityDates/SET_UNAVAILABILITY_DATE', null)
      $('#modal-date-form').modal('show');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityTable.vue